import { InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import * as React from 'react';
import MembersStrings from './MembersStrings';
import Button from '@doordash/component-button';
import { AddMembersModalTestId } from '../testId';
var strings = MembersStrings.informCannotAddEmailContent;
export var InviteTeamMemberErrorSections = function (_a) {
    var emails = _a.emails;
    if (emails.length === 0) {
        return null;
    }
    return (React.createElement(StackChildren, null,
        React.createElement(Text, { styles: Text.Styles.Caption1 }, emails.length === 1
            ? strings.inviteToTeamError.singleFail()
            : strings.inviteToTeamError.multipleFail(emails.length)),
        React.createElement("ul", { "data-testid": AddMembersModalTestId.AddMembersInviteToTeamError }, emails.map(function (email) {
            return (React.createElement("li", { key: email },
                ' ',
                React.createElement(Text, { styles: Text.Styles.Caption1 }, email)));
        }))));
};
// TODO: move to common components together with button group modal footer of bulk add to group
export var ButtonGroupModalFooter = function (_a) {
    var primary = _a.primary;
    return (React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
        React.createElement(React.Fragment, null,
            React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: primary.action }, primary.text)))));
};
export var InformCannotAddEmailContent = function (_a) {
    var setTitle = _a.setTitle, errors = _a.errors, onOk = _a.onOk;
    var emailsBelongsToOtherTeams = errors.map(function (error) { return error.email; });
    React.useEffect(function () {
        if (setTitle && errors.length) {
            setTitle(errors.length > 1
                ? strings.title.multipleFail(errors.length)
                : strings.title.singleFail());
        }
    }, [setTitle, errors]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StackChildren, { size: Stack.Sizes.Medium },
            React.createElement(InviteTeamMemberErrorSections, { emails: emailsBelongsToOtherTeams }),
            React.createElement(ButtonGroupModalFooter, { primary: { action: onOk, text: strings.button.primaryText() } }))));
};
export default InformCannotAddEmailContent;
